import { Directive, AfterViewInit, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: 'button[trSpinnerButton]',
})
export class TrSpinnerButtonDirective implements AfterViewInit {

    private buttonReference: any;
    private buttonSpinnerReference: any;
    // tslint:disable-next-line:variable-name
    private _busy: boolean = false;

    @Input() public set busy(value: boolean) {
        this.setBusy(value);
    }
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {
        this.buttonReference = elementRef.nativeElement;
    }

    public bind() {
        const svg = this.renderer.createElement('svg', 'svg');
        this.renderer.addClass(svg, 'spinner')
        this.renderer.setAttribute(svg, 'viewBox', '0 0 66 66')
        this.renderer.setAttribute(svg, 'xmlns', 'http://www.w3.org/2000/svg')

        
        const circle = this.renderer.createElement('circle', 'svg');
        this.renderer.addClass(circle, 'path')
        this.renderer.setAttribute(circle, 'fill', 'none')
        this.renderer.setAttribute(circle, 'stroke-width', '6')
        this.renderer.setAttribute(circle, 'stroke-linecap', 'round')
        this.renderer.setAttribute(circle, 'cx', '33')
        this.renderer.setAttribute(circle, 'cy', '33')
        this.renderer.setAttribute(circle, 'r', '30')

        this.renderer.appendChild(svg, circle)
        this.renderer.appendChild(this.buttonReference, svg)

    }

    public ngAfterViewInit() {
        this.bind();
    }

    public setBusy(value: boolean) {
        this._busy = value;

        if (value) {
            this.renderer.addClass(this.buttonReference, 'busy')
        } else {
            this.renderer.removeClass(this.buttonReference, 'busy')
        }
    }
}
